// BinkoIcons.jsx — brand-aligned SVG icons, replaces MUI + emoji
// All icons: 1.8px stroke, rounded caps, color via prop, defaults to brand tokens
import React from 'react';
import { C } from './theme';

function Icon({ size = 24, color, children, style }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
      stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"
      style={{ display: 'inline-block', flexShrink: 0, ...style }} aria-hidden="true">
      {children}
    </svg>
  );
}

export function IconTrophy({ color = C.yellow, size = 24, style }) {
  return (
    <Icon size={size} color={color} style={style}>
      <path d="M6 9H4a2 2 0 0 1-2-2V5h4"/>
      <path d="M18 9h2a2 2 0 0 0 2-2V5h-4"/>
      <path d="M6 9c0 4 2.5 7 6 8 3.5-1 6-4 6-8V3H6v6z"/>
      <path d="M9 21h6"/><path d="M12 17v4"/>
    </Icon>
  );
}

const MEDAL_COLORS = { 1: C.yellow, 2: C.textMuted, 3: C.orange };
export function IconMedal({ rank = 1, size = 20, style }) {
  return (
    <Icon size={size} color={MEDAL_COLORS[rank] || C.textMuted} style={style}>
      <circle cx="12" cy="8" r="6"/>
      <path d="M8.56 2.75c4.37 6.03 6.02 9.42 8.03 17.72m2.54-15.38c-3.72 4.35-8.94 5.66-16.88 5.85m19.5 1.9c-3.5-.93-6.63-.82-8.94 0-2.58.92-5.01 2.86-7.44 6.32"/>
    </Icon>
  );
}

export function IconCorrect({ color = C.success, size = 24, style }) {
  return (
    <Icon size={size} color={color} style={style}>
      <circle cx="12" cy="12" r="10"/><path d="M8 12l3 3 5-5"/>
    </Icon>
  );
}

export function IconWrong({ color = C.orange, size = 24, style }) {
  return (
    <Icon size={size} color={color} style={style}>
      <circle cx="12" cy="12" r="10"/>
      <path d="M15 9l-6 6"/><path d="M9 9l6 6"/>
    </Icon>
  );
}

export function IconNoAnswer({ color = C.textDisabled, size = 24, style }) {
  return (
    <Icon size={size} color={color} style={style}>
      <circle cx="12" cy="12" r="10" strokeDasharray="4 2"/>
      <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
      <circle cx="12" cy="17" r="0.5" fill={color} stroke="none"/>
    </Icon>
  );
}

export function IconBolt({ color = C.yellow, size = 24, style }) {
  return (
    <Icon size={size} color={color} style={style}>
      <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
    </Icon>
  );
}

export function IconFlame({ color = C.orange, size = 24, style }) {
  return (
    <Icon size={size} color={color} style={style}>
      <path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z"/>
    </Icon>
  );
}

export function IconPause({ color = C.teal, size = 24, style }) {
  return (
    <Icon size={size} color={color} style={style}>
      <rect x="6" y="4" width="4" height="16" rx="1"/>
      <rect x="14" y="4" width="4" height="16" rx="1"/>
    </Icon>
  );
}

export function IconWave({ color = C.teal, size = 24, style }) {
  return (
    <Icon size={size} color={color} style={style}>
      <path d="M18 11V6a2 2 0 0 0-4 0v5"/>
      <path d="M14 10V4a2 2 0 0 0-4 0v6"/>
      <path d="M10 10.5V6a2 2 0 0 0-4 0v8"/>
      <path d="M18 8a2 2 0 1 1 4 0v6a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15"/>
    </Icon>
  );
}

export function IconStats({ color = C.textMuted, size = 24, style }) {
  return (
    <Icon size={size} color={color} style={style}>
      <line x1="18" y1="20" x2="18" y2="10"/>
      <line x1="12" y1="20" x2="12" y2="4"/>
      <line x1="6"  y1="20" x2="6"  y2="14"/>
    </Icon>
  );
}

export function IconLocation({ color = C.textMuted, size = 14, style }) {
  return (
    <Icon size={size} color={color} style={style}>
      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
      <circle cx="12" cy="10" r="3"/>
    </Icon>
  );
}

export function IconTick({ color = C.success, size = 16, style }) {
  return (
    <Icon size={size} color={color} style={style}>
      <polyline points="20 6 9 17 4 12"/>
    </Icon>
  );
}

export function IconMessageCircle({ color, size = 22, style }) {
  return (
    <Icon size={size} color={color} style={style}>
      <path d="M12 6C8.686 6 6 8.686 6 12c0 1.29.387 2.49 1.05 3.49L6 21l5.51-1.05A6 6 0 1 0 12 6z"/>
    </Icon>
  );
}
